import { actions } from "User/store/actions";
import { getters } from "User/store/getters";
import { state } from "User/store/state";
import { mutations } from "User/store/mutations";

/**
 * Контекст содержит в себе данные текущего окружения, такие как ширина экрана
 */
const namespace = "user";

const store = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export { namespace, store, getters, actions };